import React from 'react';
import FormField from '../form/FormField';
import {createRefetchContainer, graphql,} from "react-relay";
import PropTypes from "prop-types";
import {Constraint} from "@aperza/validator";

class FormJobCategoryTypeField extends React.Component {

  static propTypes = {
    viewer: PropTypes.any,
    readOnly: PropTypes.bool,
    value: PropTypes.any,
    businessTypeName:PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    }
  }

  onBlur(fieldName, value) {
    if (this.props.onBlur) {
      this.props.onBlur(fieldName, value);
    }
  }

  onChange(fieldName, value) {
    if (this.props.onChange) {
      this.props.onChange(fieldName, value);
    }
  }

  componentDidMount() {
    if (this.props.businessTypeName) {
      this.refetch();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.businessTypeName !== prevProps.businessTypeName) {
      this.refetch();
    }
  }

  refetch() {
    this.setState({ loading: true });
    this.props.relay.refetch(
      {
        businessTypeName: this.props.businessTypeName,
      },
      null,  // We can use the refetchVariables as renderVariables
      (error) => {
        console.log('Finished fetching');
        this.setState({ loading: false });
      },
      { force: false }  // Assuming we've configured a network layer cache, we want to ensure we fetch the latest data.
    );
  }

  render() {
    let {
      readOnly,
      errorId,
      invalid,
      value,
      viewer = {},
    } = this.props;

    let {
      jobCategoryTypes = [],
    } = viewer;

    let {
      loading,
    } = this.state;

    let options = jobCategoryTypes.map(jobCategoryType => {
      return [jobCategoryType.name, jobCategoryType.label];
    });
    return (
      <FormField
        fieldName={'job_category_types'}
        constraint={Constraint.jobCategoryType}
        options={options}
        readOnly={readOnly}
        invalid={invalid}
        errorId={errorId}
        value={value}
        loading={loading}
        onBlur={::this.onBlur}
        onChange={::this.onChange} />

    )
  }

}

export default createRefetchContainer(
  FormJobCategoryTypeField,
  {
    viewer: graphql`
        fragment FormJobCategoryTypeField_viewer on Viewer
        @argumentDefinitions(
            businessTypeName: {type: "String"},
        ),
        {
            jobCategoryTypes(businessTypeName: $businessTypeName) {
                id
                plainId
                name
                label
            }
        }
    `
  },
  graphql`
      query FormJobCategoryTypeFieldRefetchQuery($businessTypeName:String) {
          viewer {
              ...FormJobCategoryTypeField_viewer @arguments(
                  businessTypeName: $businessTypeName)
          }
      }
  `
);
